import { Col, Row } from 'antd';
import { SlicerResultPage } from 'Utils/UtilityFunctions';
import CompanySkeleton from './CompanySkeleton';

type Props = {
  sliceFlag?: boolean;
  inGlobalSearch?: boolean,
};

const defaultProps: Props = {
  sliceFlag: false,
  inGlobalSearch: false,
};

const SearchCompanySkeletonBlock = function SearchCompanySkeletonBlock(props: Props) {
  const { sliceFlag, inGlobalSearch } = props;
  const slicerGroupNumber = SlicerResultPage();

  const skeletonArray = Array.from({ length: 12 }, (_, index) => index + 1);
  const arrayLength = !sliceFlag ? 12 : slicerGroupNumber;
  return (
    <Row
      gutter={[{
        xs: 16, lg: 40, md: 32, sm: 32,
      }, 8]}
      className="Grid-width-row gridUpdated col-six-fix-md"
    >
      {skeletonArray.slice(0, arrayLength).map((item) => (
        <Col span={6} xs={12} md={4} lg={4} sm={4} className="gutter-row" key={item}>
          <CompanySkeleton inGlobalSearch={inGlobalSearch} />
        </Col>
      ))}
    </Row>
  );
};
SearchCompanySkeletonBlock.defaultProps = defaultProps;
export default SearchCompanySkeletonBlock;
